import { ApolloClient } from '@apollo/client/core';
import { FETCH_PARENT_REGISTRATION } from '@/graphql/account/queries';
import { redirect } from '@/helpers/redirects';

export async function redirectParentRegistration(apolloClient: ApolloClient<any>, returnPath?: string): Promise<boolean> {
  try {
    const { data } = await apolloClient.query({
      query: FETCH_PARENT_REGISTRATION,
      fetchPolicy: 'cache-first',
    });
    const { postalAddress } = data.parentRegistration;
    const resolvedReturnPath =
      returnPath ||
      (() => {
        const { pathname, search } = new URL(window.location.href);
        return pathname + search;
      })();

    if (!postalAddress) {
      redirect(`/registration/location?return_path=${encodeURIComponent(resolvedReturnPath)}`);
      return true;
    }
    return false;
  } catch (err) {
    console.error('Error fetching parent registration:', err);
    throw err;
  }
}

export async function redirectCareTypeRegistration(apolloClient: ApolloClient<any>) {
  try {
    const { data } = await apolloClient.query({
      query: FETCH_PARENT_REGISTRATION,
      fetchPolicy: 'cache-first',
    });
    const { careType } = data.parentRegistration;

    if (!careType) {
      redirect('/registration/care_type');
    }
  } catch (err) {
    console.error('Error fetching parent registration:', err);
    throw err;
  }
}
